// extracted by mini-css-extract-plugin
export default {"ratingList":"cq_j7","item":"cq_gQ","label":"cq_fN","value":"cq_j8","tbaValue":"cq_j9","showOnlyMobile":"cq_kb"};